import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Container } from "./styles.js";
import CurrencyInput from "react-currency-input";
import { formatReal, formatMoney } from "../../helpers";
import { Creators as CalculadoraActions } from "../../store/ducks/calculadora";

class Calculadora extends Component {
  state = {
    parcela: 0,
    coeficiente: 0.02998,
    valor: "0,00",
    valor_liberado: 0,
    coeficiente_b: 0.02998,
    valor_parcela: "0,00"
  };

  handleCalculate = () => {
    let total = formatReal(
      parseFloat(
        (formatMoney(this.state.parcela) / this.state.coeficiente).toFixed(2)
      )
    );
    this.setState({
      valor: total
    });
  };

  handleCalculateB = () => {
    let total = formatReal(
      parseFloat(
        (
          formatMoney(this.state.valor_liberado) * this.state.coeficiente_b
        ).toFixed(2)
      )
    );
    this.setState({
      valor_parcela: total
    });
  };

  componentDidMount() {
    this.dragElement(document.getElementById("calculadora"));
  }

  dragElement = elmnt => {
    var pos1 = 0,
      pos2 = 0,
      pos3 = 0,
      pos4 = 0;
    if (document.getElementById(elmnt.id + "header")) {
      document.getElementById(elmnt.id + "header").onmousedown = dragMouseDown;
    } else {
      elmnt.onmousedown = dragMouseDown;
    }

    function dragMouseDown(e) {
      e = e || window.event;
      e.preventDefault();
      pos3 = e.clientX;
      pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      document.onmousemove = elementDrag;
    }

    function elementDrag(e) {
      e = e || window.event;
      e.preventDefault();
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      elmnt.style.top = elmnt.offsetTop - pos2 + "px";
      elmnt.style.left = elmnt.offsetLeft - pos1 + "px";
    }

    function closeDragElement() {
      document.onmouseup = null;
      document.onmousemove = null;
    }
  };

  render() {
    return (
      <Container>
        <div id="calculadora">
          <div className="calculadora-header" id="calculadoraheader">
            Simulador Livre
            <i
              className="fa fa-times-circle"
              onClick={() => this.props.closeCalculadora()}
            />
          </div>
          <div className="calculadora-body">
            <table>
              <thead>
                <tr>
                  <th>Parcela</th>
                  <th>Coeficiente</th>
                  <th />
                  <th>Valor Liberado</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <CurrencyInput
                      decimalSeparator=","
                      thousandSeparator="."
                      value={this.state.parcela}
                      className="max-width-8rem"
                      onChange={val =>
                        this.setState({
                          parcela: val
                        })
                      }
                    />
                  </td>
                  <td>
                    <CurrencyInput
                      precision="6"
                      decimalSeparator="."
                      thousandSeparator=""
                      value={this.state.coeficiente}
                      className="max-width-8rem"
                      onChange={val =>
                        this.setState({
                          coeficiente: val
                        })
                      }
                    />
                  </td>
                  <td>
                    <button
                      className="botao-simulador"
                      onClick={() => this.handleCalculate()}
                    >
                      <i className="fa fa-calculator" />
                      Simular
                    </button>
                  </td>
                  <td>
                    {parseInt(this.state.valor, 10) >= 0 ? (
                      <span className="highlight blue-alert">
                        {this.state.valor}
                      </span>
                    ) : (
                      <span className="highlight red-alert">
                        {this.state.valor}
                      </span>
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
            <hr />
            <table className="mt1">
              <thead>
                <tr>
                  <th style={{ width: "108px" }}>Valor Liberado</th>
                  <th style={{ width: "108px" }}>Coeficiente</th>
                  <th style={{ width: "108px" }} />
                  <th>Parcela</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <CurrencyInput
                      decimalSeparator=","
                      thousandSeparator="."
                      value={this.state.valor_liberado}
                      className="max-width-8rem"
                      onChange={val =>
                        this.setState({
                          valor_liberado: val
                        })
                      }
                    />
                  </td>
                  <td>
                    <CurrencyInput
                      precision="6"
                      decimalSeparator="."
                      thousandSeparator=""
                      value={this.state.coeficiente_b}
                      className="max-width-8rem"
                      onChange={val =>
                        this.setState({
                          coeficiente_b: val
                        })
                      }
                    />
                  </td>
                  <td>
                    <button
                      className="botao-simulador"
                      onClick={() => this.handleCalculateB()}
                    >
                      <i className="fa fa-calculator" />
                      Simular
                    </button>
                  </td>
                  <td>
                    {parseInt(this.state.valor_parcela, 10) >= 0 ? (
                      <span className="highlight blue-alert">
                        {this.state.valor_parcela}
                      </span>
                    ) : (
                      <span className="highlight red-alert">
                        {this.state.valor_parcela}
                      </span>
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </Container>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      ...CalculadoraActions
    },
    dispatch
  );

export default connect(
  null,
  mapDispatchToProps
)(Calculadora);



// WEBPACK FOOTER //
// ./src/components/Calculadora/index.js